import React, { useState } from 'react';
import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import {
  InputSelect,
  DatePickerInput,
  TextAreaInput,
} from '@wajeez-web/components/ui';
import { Identity } from '@wajeez-web/core/api-base';

interface AddBusinessSubsicriptionModalProps
  extends CommonModalProps<Identity.CreateBusinessGroupSubscriptionInput> {
  allPlans: { label: string; value: number }[];
}

const AddBusinessSubsicriptionModal: React.FC<
  AddBusinessSubsicriptionModalProps
> = ({ isOpen, allPlans, onClose, onSubmit }) => {
  const [businessSubscriptionValues, setBusinessSubscriptionValue] =
    useState<Identity.CreateBusinessGroupSubscriptionInput>({
      planId: 0,
      startsOn: undefined,
      expiresOn: undefined,
      notes: '',
    });

  const handleSubscriptionValuesChange = (name: string, value: any) => {
    setBusinessSubscriptionValue({
      ...businessSubscriptionValues,
      [name]: value,
    });
  };
  return (
    <Modal
      title="Add Business Subscription"
      open={isOpen}
      onClose={onClose}
      onSubmit={() => {
        onSubmit && onSubmit(businessSubscriptionValues);
      }}
    >
      <div className="space-y-2 scrollbar overflow-y-scroll h-full">
        <InputSelect
          options={allPlans}
          value={allPlans.find(
            (item) => item.value === businessSubscriptionValues.planId
          )}
          required={true}
          label={'Plan'}
          name="planId"
          onChange={(name, value: any) =>
            handleSubscriptionValuesChange(name, value.value)
          }
        />
        <DatePickerInput
          label="Starts Date"
          name="startsOn"
          value={businessSubscriptionValues.startsOn}
          onChange={handleSubscriptionValuesChange}
        />
        <DatePickerInput
          label="Expire Date"
          name="expiresOn"
          value={businessSubscriptionValues.expiresOn}
          onChange={handleSubscriptionValuesChange}
        />
        <TextAreaInput
          label="Notes"
          name="notes"
          value={businessSubscriptionValues.notes || ''}
          onChange={handleSubscriptionValuesChange}
        />
      </div>
    </Modal>
  );
};

export default AddBusinessSubsicriptionModal;
